import { STALE_PENDING_THRESHOLD_DAYS } from "encamp-shared/src/waste";
import {
  DISCREPANCY_STATUS_FILTER_VALUES,
  discrepancyStatusFilterLabel,
} from "routes/Customer/Waste/Manifests/discrepancyStatusFilter";

/**
 * Staff-only filter value: a PENDING discrepancy whose `pendingAt` is older
 * than the staleness threshold. Kept out of `DISCREPANCY_STATUS_FILTER_VALUES`
 * because that list is read by tenant users.
 */
export const STALE_PENDING_DISCREPANCY_STATUS = "STALE_PENDING";

/** The four states the staff Manifest Review page's discrepancy filters offer. */
export const STAFF_DISCREPANCY_STATUS_FILTER_VALUES: string[] = [
  ...DISCREPANCY_STATUS_FILTER_VALUES,
  STALE_PENDING_DISCREPANCY_STATUS,
];

/**
 * Filter option label for the staff discrepancy status filters. Falls back to
 * the customer list's label for the three shared states, and only handles
 * STALE_PENDING itself since it has no equivalent chip on the customer side.
 */
export function staffDiscrepancyStatusFilterLabel(value: string): string {
  if (value === STALE_PENDING_DISCREPANCY_STATUS) {
    return `Pending over ${STALE_PENDING_THRESHOLD_DAYS} days`;
  }
  return discrepancyStatusFilterLabel(value);
}
